
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 116 90"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"115","height":"89","x":".5","y":".5","fill":"#FFF","stroke":"#71798A","rx":"4"}}),_c('g',{attrs:{"transform":"translate(30 7)"}},[_c('circle',{attrs:{"cx":"17","cy":"21","r":"6","fill":"#00B7E9"}}),_c('circle',{attrs:{"cx":"50","cy":"6","r":"6","fill":"#00B7E9"}}),_c('circle',{attrs:{"cx":"30","cy":"49","r":"6","fill":"#00B7E9"}}),_c('circle',{attrs:{"cx":"41","cy":"29","r":"4","fill":"#003457"}}),_c('circle',{attrs:{"cx":"4","cy":"4","r":"4","fill":"#003457"}}),_c('circle',{attrs:{"cx":"30","cy":"8","r":"4","fill":"#003457"}}),_c('circle',{attrs:{"cx":"18","cy":"38","r":"4","fill":"#003457"}})]),_c('path',{attrs:{"fill":"#C0C8D7","d":"M19.143 62c0 4.418 3.614 8 8.071 8 4.374 0 7.935-3.448 8.068-7.75l.004-.25c0 4.418 3.613 8 8.071 8s8.072-3.582 8.072-8c0 4.418 3.613 8 8.071 8 4.374 0 7.935-3.448 8.068-7.75l.003-.25c0 4.418 3.614 8 8.072 8 4.458 0 8.071-3.582 8.071-8 0 4.418 3.614 8 8.072 8A8.079 8.079 0 0099 65.59V75a8 8 0 01-8 8H27a8 8 0 01-8-8l.001-11.5c.093-.485.142-.987.142-1.5z"}})])])
          )
        }
      }
    